import React from 'react';
import Joyride, { STATUS } from 'react-joyride';
import WelcomeModal from './WelcomeModal';
import Tooltip from './Tooltip';

const steps = [
  {
    target: '.switchToFullSite, .switchToMobileSite',
    content: 'Switch between views here',
    disableBeacon: true,
    placement: 'top',
    locale: { close: 'Got It' },
  },
];

class MwebFullSiteSwitchFtue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTourRunning: !!props.isWelcomeFtueComplete,
      showWelcomeModal: !props.isWelcomeFtueComplete,
    };
  }

  render() {
    const { isTourRunning, showWelcomeModal } = this.state;

    return (
      <div>
        <WelcomeModal
          isShowing={showWelcomeModal}
          onKeepInMobileSite={this.handleKeepInMobileSite}
          onViewFullSite={this.handleViewFullSite}
        />
        <Joyride
          run={isTourRunning}
          steps={steps}
          disableCloseOnEsc
          disableOverlayClose
          callback={this.handleJoyrideCallback}
          tooltipComponent={Tooltip}
          styles={{
            options: {
              arrowColor: '#4A4A4A',
            },
          }}
        />
      </div>
    );
  }

  handleKeepInMobileSite = () => {
    const { onCompletionWelcomeModal } = this.props;
    this.setState({
      isTourRunning: true,
      showWelcomeModal: false,
    });
    onCompletionWelcomeModal();
  };

  handleJoyrideCallback = data => {
    const { status } = data;
    const { onCompletion } = this.props;

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      this.setState({ isTourRunning: false });
      onCompletion();
    }
  };

  handleViewFullSite = () => {
    const { onCompletionWelcomeModal, onViewFullSiteButtonClick } = this.props;
    this.setState({
      isTourRunning: true,
      showWelcomeModal: false,
    });
    onCompletionWelcomeModal();
    onViewFullSiteButtonClick();
  };
}

MwebFullSiteSwitchFtue.defaultProps = {
  isWelcomeFtueComplete: true,
  onCompletion: () => {},
  onCompletionWelcomeModal: () => {},
  onViewFullSiteButtonClick: () => {},
};

export default MwebFullSiteSwitchFtue;
